module.exports = __webpack_public_path__ + "static/logo_white-6f7cede9c2872745c338c70c459da5d5.png";